<template>
  <div id="addService">
    <a-form :form="form" selfUpdate layout="vertical">
      <a-form-item v-show="false">
        <a-input v-decorator="['id']"></a-input>
      </a-form-item>
      <a-form-item v-show="false">
        <a-input v-decorator="['version']"></a-input>
      </a-form-item>
      <a-form-item v-show="false">
        <a-input v-decorator="['dealId']"></a-input>
      </a-form-item>
      <a-row>
        <a-col :span="16">
          <a-form-item :label="$t('deal.service.addService.serviceAccount')" class="required">

            <pt-user-select
              v-decorator="decorators.ServiceAccountStringList" :placeholder="$t('deal.addDeal.dealSource.placeholder')" mode="multiple" maxTagCount="3"></pt-user-select>
            <!--<ptSelect v-decorator="decorators.ServiceAccountStringList" mode="multiple" :maxTagCount="3" :placeholder="$t('deal.addDeal.dealSource.placeholder')">-->
              <!--<a-select-option v-for="a in accountList" :key="a.id" :value="a.id">{{a.loginName}}</a-select-option>-->
            <!--</ptSelect>-->
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :label="$t('deal.service.addService.serviceTime')">
            <a-date-picker style="width:100%;" v-decorator="decorators.serviceTime" :allow-clear="false"></a-date-picker>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-form-item :label="$t('deal.service.addService.content')">
          <ptInput v-decorator="decorators.content" :max-length="500" type="textarea" :autosize="{minRows:3,maxRows:3}"></ptInput>
        </a-form-item>
      </a-row>
    </a-form>
    <div class="fileRow">
      <div class="fileRowLeft">
        <div class="circle"></div>
        <div class="fileTitle">{{$t('deal.service.addService.serviceFile')}}</div>
        <div class="fileTip">{{$t('lease.modal.filesTip')}}</div>
      </div>
      <pt-oss-upload @onSuccess="onSuccess">
        <a-button size="small"><pt-icon type="icon-shangchuanfujian"></pt-icon>{{$t('lease.modal.uploadFile')}}</a-button>
      </pt-oss-upload>
    </div>
    <a-row class="fileDiv">
      <div v-if="fileList.length > 0">
        <div v-for="(item,index) in fileList" :key="index" class="fileItem">
          <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
          <div class="fileName">{{item.fileName}}</div>
          <div @click="delFile(index)">
            <pt-icon class="delIcon" type="icon-tubiao"></pt-icon>
          </div>
        </div>
      </div>
      <div v-else class="noFileClass">
        {{$t('baseVO.empty')}}
      </div>
    </a-row>

  </div>
</template>

<script>
  import accountApi from '@/api/mine/account'
  import serviceApi from '@/api/mine/service'

  export default {
    name: 'addService',
    props: {
      dealId:{
        type:String,
        default:null,
      },
      serviceVO:{
        type:Object,
        default:()=>{return null},
      }
    },
    components:{

    },
    data() {
      return {
        fileList:[],
        accountList:[],
        form: this.$form.createForm(this, {}),
        decorators: {
          ServiceAccountStringList:[
            'ServiceAccountStringList',{rules:[
                {required: true, message:this.$t('deal.addDeal.errorInfo.dealSourcePersonStringList')},
              ]
            }
          ],
          serviceTime:[
            'serviceTime',{}
          ],
          content:[
            'content',{rules:[
                {max:500,message:'备注最多输入 500 个字',target:['change', 'blur']}
              ]}
          ],
        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      delFile(index){
        this.fileList.splice(index,1);
      },
      init(){
        this.initAccount()
      },
      initAccount(){
        accountApi.listAll().then(res=>{
          this.accountList = res.data
          this.$nextTick(()=>{
            this.initFormDefaultValue()
          })
        })
      },
      initFormDefaultValue(){
        if(this.serviceVO){
          let serviceVO = JSON.parse(JSON.stringify(this.serviceVO))
          serviceVO.serviceTime = serviceVO.serviceTime != '~' ? this.$moment(serviceVO.serviceTime) : this.$moment()
          serviceVO.ServiceAccountStringList = serviceVO.serviceAccountDOS.map(e=>{return e.accountId })
          if(serviceVO.serviceFileVOS){
            this.fileList = serviceVO.serviceFileVOS
          }
          this.form.setFieldsValue(serviceVO)
        }else{
          this.form.setFieldsValue({serviceTime: this.$moment()})
        }
      },
      onSuccess(file,fileId){
        this.fileList.push(Object.assign(file,{fileName:file.name,serviceFileDO:{fileId:fileId}}))
      },
      submit(){
        let this_ = this
        this.form.validateFields(err=>{
          if(!err){
            let serviceVO = this.form.getFieldsValue()
            serviceVO.serviceFileVOS = this.fileList
            serviceVO.serviceAccountDOS = serviceVO.ServiceAccountStringList.map(e=>{return {accountId:e}})
            if(!serviceVO.id){
              serviceVO.dealId = this.dealId
              serviceApi.insert(serviceVO).then(res=>{
                if(res.code == 1){
                  this.$emit('saveServiceSuccess')
                  this.$message.success(res.message)
                }else{
                  this.$message.error(res.message)
                  this.$emit('validateFail')
                }
              })
            }else{
              serviceApi.update(serviceVO).then(res=>{
                if(res.code == 1){
                  this.$emit('saveServiceSuccess')
                  this.$message.success(res.message)
                }else{
                  this.$message.error(res.message)
                  this.$emit('validateFail')
                }
              })
            }
          }else{
            this.$emit('validateFail')
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #addService{
    .ant-row{
      padding: 10px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      margin-bottom: 0;
    }
    .fileDiv{
      padding: 20px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      .noFileClass{
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #999999;
      }
      .fileItem{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #E7E7E7;
        .fileIcon{
          font-size: 20px;
        }
        .fileName{
          flex:1;
          font-size: 12px;
          color: #333333;
          margin: 0 20px;
        }
        .delIcon{
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
    .fileRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 10px;
      .fileRowLeft{
        display: flex;
        flex-direction: row;
        align-items: center;
        .circle{
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #FABE00;
        }
        .fileTitle{
          font-size: 14px;
          color: #333333;
          margin-left: 10px;
        }
        .fileTip{
          font-size: 12px;
          color: #999999;
          margin-top: 4px;
          margin-left: 4px;
        }
      }
    }
  }
</style>